import { useEffect, useState } from 'react'
import { FilePen, Trash2 } from 'lucide-react'
import { cmsApi } from '../lib/api'
import { formatWhen } from '../lib/format'
import type { CatalogDraft } from '../types'

// The places or profiles begun in Lugares or Perfis and not created yet
// (PRD.md, item 98), as the Rascunhos of Eventos, for the whole team.
export function CatalogDrafts({ kind, onOpen, onNotice, onError }: {
  kind: CatalogDraft['kind']
  onOpen: (id: string) => void
  onNotice: (message: string) => void
  onError: (message: string) => void
}) {
  const [drafts, setDrafts] = useState<CatalogDraft[]>([])
  useEffect(() => {
    cmsApi.listCatalogDrafts(kind).then(setDrafts).catch(() => setDrafts([]))
  }, [kind])

  // Closed as discarded and kept, as from the editor.
  const remove = async (draft: CatalogDraft) => {
    if (!window.confirm(`Excluir o rascunho “${draft.title || 'Sem nome'}”? Ele sai da lista de rascunhos.`)) return
    try {
      await cmsApi.discardCatalogDraft(draft.id)
      setDrafts((current) => current.filter((item) => item.id !== draft.id))
      onNotice('Rascunho excluído.')
    } catch (requestError) {
      onError(requestError instanceof Error ? requestError.message : 'Não foi possível excluir o rascunho.')
    }
  }

  if (!drafts.length) return null
  return (
    <section className="panel panel--flush" aria-label="Rascunhos">
      <div className="panel__heading"><div><h2>Rascunhos</h2><p>{kind === 'place' ? 'Lugares' : 'Perfis'} em criação, ainda fora do app. Abra um para continuar de onde parou.</p></div></div>
      <div className="compact-event-list">
        {drafts.map((draft) => (
          <div className="draft-row" key={draft.id}>
            <button className="compact-event" onClick={() => onOpen(draft.id)}>
              <span className="compact-event__media"><FilePen size={18} /></span>
              <span className="compact-event__main">
                <strong>{draft.title || 'Sem nome'}</strong>
                <small>Criado por {draft.created_by_email}{draft.updated_by_email !== draft.created_by_email ? ` · editado por ${draft.updated_by_email}` : ''}</small>
              </span>
              <span className="compact-event__date">{formatWhen(draft.updated_at)}</span>
            </button>
            <button className="icon-button icon-button--danger" aria-label={`Excluir rascunho ${draft.title || 'Sem nome'}`} title="Excluir rascunho" onClick={() => void remove(draft)}><Trash2 size={17} /></button>
          </div>
        ))}
      </div>
    </section>
  )
}
